export default __webpack_public_path__ + "static/media/sidhanth.76fe4063.jpg";